import React, { useEffect, useState } from 'react'
import { applicantCountConstant, RESIDENT_STATUS } from '../../../config/constant';
import PropTypes from "prop-types";
import { Divider, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ReviewInput from '../../../components/ReviewInput';
import UploadPopupTwoImages from '../../../shared-components/upload-popup/UploadPopupTwoImages';
import UploadPopup from '../../../shared-components/upload-popup/UploadPopup';

const TWO_IMAGE_DOCS = new Set(["aadhaarImage"]);

const KYCDocuments = ({ applicantData, isEntityBooking, formType }) => {
  const { t } = useTranslation();
  const [openPopup, setOpenPopup] = useState(false);
  const [fieldName, setFieldName] = useState("");
  const [applicantList, setApplicantList] = useState([]);
  const [images, setImages] = useState([]);
  const [selectedDocName, setSelectedDocName] = useState("");
  const [selectedDocNumber, setSelectedDocNumber] = useState("");

  useEffect(() => {
    let obj = [];
    if (applicantData && applicantData?.applicant1 !== null) {
      obj?.push(applicantData?.applicant1);
    }
    if (applicantData && applicantData?.applicant2 !== null) {
      obj?.push(applicantData?.applicant2);
    }
    if (formType !== "voucher"){
      if (applicantData && applicantData?.applicant3 !== null) {
        obj?.push(applicantData?.applicant3);
      }
      if (applicantData && applicantData?.applicant4 !== null) {
        obj?.push(applicantData?.applicant4);
      }
    }
    setApplicantList(obj);
  }, [applicantData, formType]);

  const handleView = (name, docs, title, number) => {
    setFieldName(name);
    setImages(docs[name] || []);
    setOpenPopup(true);

    if (formType === "voucher") {
    setSelectedDocName(title);
    setSelectedDocNumber(number || "");
  }
  };

  return (
    <div className="kycDocument">
      <div className="applicantDetailsCard">
        <h3 className="titlePersonalHD marginBottom28">
          {t("preview.kycDocuments")}
        </h3>
        {applicantList &&
          applicantList?.length > 0 &&
          applicantList?.map((data, index) => {
            let personal = {};
            if (formType === "voucher") {
              personal = data?.contactDetails || {}
            } else {
              personal = data?.personalDetails || {}
            }
            const documents = {
              aadhaarImage: personal?.aadhaarImage || [],
              panCard: personal?.panImage || [],
              passportImage: personal?.passportImage || [],
              ociImage: personal?.ociImage || [],
              addressProofImage: personal?.addressProofImage || [],
              gstCertificate: data?.professionalDetails?.gstCertificate || [],
            };
            return (
              <>
                <div className="editTitleRow">
                  <div className="btnApplicantTop">
                    {isEntityBooking ? (
                      <>
                        {index + 1 > 1 && (
                          <>
                            {index + 1}
                            <sup>{applicantCountConstant?.numberKeys[index + 1]}</sup>
                          </>
                        )}{" "}
                        {t("preview.authorizedSignatory")}
                      </>
                    ) : (
                      <>
                        {index === 0 ? (
                          "Primary Applicant"
                        ) : (
                          <>
                            {index + 1}
                            <sup>{applicantCountConstant?.numberKeys[index + 1]}</sup> Applicant
                            {data?.hasContinuedAsMinor ? " - Minor" : ""}
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>

                <Grid container rowSpacing={2} columnSpacing={10}>
                  {!personal?.isAadhaarSkipped &&  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <ReviewInput
                      text={t("commonLabels.aadhaarImage")}
                      name="aadhaarImage"
                      onView={() => handleView(
                        "aadhaarImage", 
                        documents, 
                        t("commonLabels.aadhaarImage"),
                        formType === "voucher" ? data?.contactDetails?.aadhaarNumber : "")
                      }
                      disabled={!documents?.aadhaarImage?.length}
                      isPhysicalDoc= {personal?.isPhysicalAadhaar}
                      documentNumber={data?.contactDetails?.aadhaarNumber}
                    />
                  </Grid>}
                  {!personal?.isPanSkipped && <Grid item xs={12} sm={6} md={6} lg={6}>
                    <ReviewInput
                      text={t("reviewCompanyDetails.labels.panCard")}
                      name="panCard"
                      onView={() => handleView(
                        "panCard", 
                        documents, 
                        t("reviewCompanyDetails.labels.panCard"),
                        formType === "voucher" ? data?.contactDetails?.panNumber : ""
                      )}
                      disabled={!documents?.panCard?.length}
                      isPhysicalDoc= {personal?.isPhysicalPan}
                      documentNumber={data?.contactDetails?.panNumber}
                    />
                  </Grid>}

                  {!personal?.isPassportSkipped && (data?.personalDetails?.residentStatus === RESIDENT_STATUS.Nri || data?.personalDetails?.residentStatus === RESIDENT_STATUS.Oci) && (
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <ReviewInput
                        text={t("reviewCompanyDetails.labels.passport")}
                        name="passportImage"
                        onView={() => handleView(
                          "passportImage", 
                          documents, 
                          t("reviewCompanyDetails.labels.passport"),
                          formType === "voucher" ? data?.contactDetails?.passportNumber : ""
                        )}
                        disabled={!documents?.passportImage?.length}
                        isPhysicalDoc={personal?.isPhysicalPassport}
                        documentNumber={data?.contactDetails?.passportNumber}
                      />
                    </Grid>
                  )}

                  {data?.personalDetails?.residentStatus === RESIDENT_STATUS.Oci && (documents?.ociImage?.length > 0|| personal?.isPhysicalOCI) && (
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <ReviewInput
                        text={t("reviewCompanyDetails.labels.oci")}
                        name="ociImage"
                        onView={() => handleView(
                          "ociImage", 
                          documents, 
                          t("reviewCompanyDetails.labels.oci"),
                          formType === "voucher" ? data?.contactDetails?.ociNumber : ""
                        )}
                        disabled={!documents?.ociImage?.length}
                        isPhysicalDoc={personal?.isPhysicalOCI}                        
                        documentNumber={data?.contactDetails?.ociNumber}
                      />
                    </Grid>)}

                  {(documents?.addressProofImage?.length > 0 || personal?.isPhysicalAddressProof) && (
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <ReviewInput
                        text={t("reviewCompanyDetails.labels.addressProof")}
                        name="addressProofImage"
                        onView={() => handleView("addressProofImage", documents)}
                        disabled={!documents?.addressProofImage?.length}
                        isPhysicalDoc={personal?.isPhysicalAddressProof}                         
                      />
                    </Grid>
                  )}

                  {(documents?.gstCertificate?.length > 0 || data?.professionalDetails?.isPhysicalGST) && (
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <ReviewInput
                        text={t("preview.professionalDetails.gstCertificate")}
                        name="gstCertificate"
                        onView={() => handleView("gstCertificate", documents)}
                        disabled={!documents?.gstCertificate?.length}
                        isPhysicalDoc={data?.professionalDetails?.isPhysicalGST}                         
                      />
                    </Grid>
                  )}

                </Grid>
                {openPopup && (
                  TWO_IMAGE_DOCS.has(fieldName) ? (
                    // Check the file extension of the first Aadhaar document
                    images[0]?.toLowerCase()?.endsWith(".pdf") ? (
                      <UploadPopup
                        heading="View"
                        totalImages={1}
                        closePopup={() => setOpenPopup(false)}
                        uploadedImage={images[0] ? [images[0]] : []}
                        fieldName={fieldName}
                        hidePhysicalCopyOption
                        dynamicSize={1}
                        hideCameraOption={false}
                        showDeleteIcon={false}
                        documentName={selectedDocName}
                        documentNumber={selectedDocNumber}
                      />
                    ) : (
                      <UploadPopupTwoImages
                        heading="View"
                        totalImages={images?.length}
                        closePopup={() => setOpenPopup(false)}
                        uploadedImageFront={images[0] || null}
                        uploadedImageBack={images[1] || null}
                        fieldName={fieldName}
                        hidePhysicalCopyOption
                        dynamicSize={1}
                        showDeleteIcon={false}
                        showPreview={true}
                        documentName={selectedDocName}
                        documentNumber={selectedDocNumber}
                      />
                    )
                  ) : (
                    <UploadPopup
                      heading="View"
                      totalImages={1}
                      closePopup={() => setOpenPopup(false)}
                      uploadedImage={images[0] ? [images[0]] : []}
                      fieldName={fieldName}
                      hidePhysicalCopyOption
                      dynamicSize={1}
                      hideCameraOption={false}
                      showDeleteIcon={false}
                      documentName={selectedDocName}
                      documentNumber={selectedDocNumber}
                    />
                  )
                )}
                {index !== applicantList?.length - 1 && (
                  <Divider sx={{ border: '1px dashed #D6D6D6', mb: 3, mt: 2 }} />
                )}
              </>
            );
          })}
      </div>
    </div>
  );
}



KYCDocuments.propTypes = {
  applicantData: PropTypes.object,
  formType: PropTypes.any,
  isEntityBooking: PropTypes.bool,
};

export default KYCDocuments